/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Rail_EyebrowInputs */

const en_portal_rail_eyebrow = /** @type {(inputs: Portal_Rail_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you get`)
};

const pl_portal_rail_eyebrow = /** @type {(inputs: Portal_Rail_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co dostajesz`)
};

/**
* | output |
* | --- |
* | "What you get" |
*
* @param {Portal_Rail_EyebrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_rail_eyebrow = /** @type {((inputs?: Portal_Rail_EyebrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Rail_EyebrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_rail_eyebrow(inputs)
	return en_portal_rail_eyebrow(inputs)
});